var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuizChoiceForm',_vm._g({attrs:{"data":_vm.data,"staticAnswers":true,"title":_vm.$t('QUIZZES.LABEL.TRUE_FALSE_SCREEN'),"showManualCheck":_vm.showManualCheck}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }